const industries = [
  { icon: 'ri-bank-line', name: 'BFSI & Fintech', desc: 'Core banking, digital lending, RegTech and tokenized securities.' },
  { icon: 'ri-building-4-line', name: 'Real Estate', desc: 'Property platforms, tokenization, marketplace and investor portals.' },
  { icon: 'ri-hospital-line', name: 'Healthcare', desc: 'EHR, telemedicine, medical AI copilots and HIPAA-compliant clouds.' },
  { icon: 'ri-truck-line', name: 'Logistics', desc: 'Fleet, TMS, warehouse automation and predictive routing.' },
  { icon: 'ri-shopping-bag-3-line', name: 'Retail & eCom', desc: 'Headless commerce, personalisation and AI merchandising.' },
  { icon: 'ri-government-line', name: 'Government', desc: 'Citizen portals, secure data centres and sovereign cloud.' },
  { icon: 'ri-graduation-cap-line', name: 'EdTech', desc: 'LMS, adaptive learning and AI tutoring platforms.' },
  { icon: 'ri-building-line', name: 'Manufacturing', desc: 'IIoT, digital twins and AI-driven quality operations.' },
];

export default function Industries() {
  return (
    <section id="industries" className="relative bg-background-100 py-20 md:py-28">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-12 md:mb-14">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-800 text-xs font-semibold uppercase tracking-wider">
              <i className="ri-briefcase-4-line"></i>
              Industries
            </div>
            <h4 className="mt-5 font-heading font-bold text-3xl md:text-5xl text-foreground-900 leading-tight">
              <a href="#industries" className="hover:text-primary-700 transition-colors cursor-pointer">
                Deep domain, delivered by teams who've shipped in your sector.
              </a>
            </h4>
          </div>
          <p className="text-base text-foreground-600 lg:max-w-sm leading-relaxed">
            15+ years of enterprise delivery means our engineers speak the language of
            your regulators, your operators and your customers — from day one.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {industries.map((i) => (
            <div key={i.name} className="group p-5 md:p-6 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer">
              <div className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-100 text-primary-700 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors mb-4">
                <i className={`${i.icon} text-xl`}></i>
              </div>
              <div className="font-heading font-semibold text-base text-foreground-900">{i.name}</div>
              <div className="text-xs text-foreground-600 mt-1.5 leading-relaxed hidden sm:block">{i.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}